<template>
    <div id="hero">
        <section id="hero-section">
            <div class="container-fluid">
                <div class="row justify-content-center">
                    <div class="col-lg-10 col-sm-12">
                        <div class="row justify-content-between">
                            <div class="col-12 col-md-7 order-md-1 order-2">
                        <div class="intro-message pt-md-5 mt-md-5">
                            <h1 class="h1-title">WAIT. One Last step!⏳</h1>
                            <p>You received a message with a link to set your account's password.<br>
                              This step is required - without it, the application cannot be completed. </p>
                            <p></p>
                            <p>The instructions are in the message.📩</p>
                            <p class="no-cv mt-5">If you don't see it, please check your spam folder or contact us</p>
                            <ul class="mt-2 d-flex p-0 list-unstyled">
                                <li>
                                    <router-link :to="{name: 'applied'}" class="btn btn-hero btn-hero-primary">Next</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                            <div class="col-12 col-md-5 order-md-2 order-1">
                                <img class="mx-auto img-fluid w-100 last-step" alt="last step"
                                     src="img/stop-icon.png">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    // import AnimatedCircles from '../AnimatedCircles.vue';

    export default {
        name: 'job-hero',
        components: {
            // 'animated-circles': AnimatedCircles,
        },
    }
</script>

<style lang="css" scoped>
    #hero-section {
        min-height: 100vh;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        overflow: hidden;
        color: #fff;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        content: "";
        z-index: 1;
        -webkit-box-align: center;
        -ms-flex-align: center;
        position: relative;
       /* background-image: url("/img/why-choose-us/background.svg"), linear-gradient(309deg, #000000 51%, #771bae);*/
      background-image: linear-gradient(309deg, #000000 51%, #771bae);
        background-attachment: fixed;
      font-size: 20px;
        background-size: cover;
    }
    .h1-title {
        font-size: 4rem !important;
    }
    .btn-hero {
        height: 48px;
        min-width: 240px;
        font-weight: bold;
        border-radius: 21px;
        cursor: pointer;
        font-size: 20px;
        border: none;
        padding-top: 10px;
    }
    .last-step {
      user-drag: none;
      -webkit-user-drag: none;
      user-select: none;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
    }
    .btn-hero-primary, .btn-hero-primary:hover, .btn-hero-primary:focus, .btn-hero-primary:active {
        color: #ffffff;
        background-image: linear-gradient(101deg, #5b9bfb 2%, #00c092 96%) !important;
        padding-top: 10px;
        outline: none;
        border: none;
        transition: 0.3s;
    }
    .btn-hero-primary:hover {
        color: #751da7;
    }
    .no-cv{
      color: #14D1BD !important;;
    }
    .btn-hero-secondary {
        color: #751da7;
        background: #fff;
    }
    .btn-hero-secondary:hover {
        color: #751da7;
        background: #e0e0e0;
    }
    @media (max-width: 780px) {
      .h1-title {

        font-size: 2.8rem !important;
      }
        #hero-section {
            min-height: calc(100vh);
          font-size: 16px !important;
        }

        .container-fluid{

        }
    }
</style>
